import { useState, useEffect } from "react";

const useAuth = () => {
  // On initialise une seule fois au chargement
  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem("user");
    if (!storedUser) return null;
    
    try {
      return JSON.parse(storedUser);
    } catch (e) {
      return null;
    }
  });

  
  return { user, setUser };
};

export default useAuth;